import React from 'react';
import { formColumnsWidth } from '../../../pageForm/PageHeadersWidthConfig';
import SortableHeaderLabel from '../../../pageForm/SortableHeaderLabel';
import { StyledFormUIRow } from '../DataModelerCommonUI';
import { Order } from '../../../../utils/apollo/graphqlSchema';
import { SortableFieldColumnKeys } from './utils';

interface IProps {
  onColumnClickFn: (k: SortableFieldColumnKeys) => () => void;
  sortOrderOrNull: Order | null;
  sortColumn: SortableFieldColumnKeys;
}

const DataModelerFieldsGridHeader = ({
  onColumnClickFn,
  sortOrderOrNull,
  sortColumn,
}: IProps) => {
  const sortOrder = sortOrderOrNull ?? Order.Asc;

  return (
    <StyledFormUIRow
      $isHeader
      $gridTemplateColumns={formColumnsWidth.dataModelerFieldsEditor}
    >
      <SortableHeaderLabel
        onClick={onColumnClickFn('fieldClass')}
        activeSortType={sortOrder}
        text={'Class'}
        isActive={sortColumn === 'fieldClass'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('name')}
        activeSortType={sortOrder}
        text={'Name'}
        isActive={sortColumn === 'name'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('description')}
        activeSortType={sortOrder}
        text={'Description'}
        isActive={sortColumn === 'description'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('column')}
        activeSortType={sortOrder}
        text={'Field Key'}
        isActive={sortColumn === 'column'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('tables')}
        activeSortType={sortOrder}
        text={'Column(s)'}
        isActive={sortColumn === 'tables'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('type')}
        activeSortType={sortOrder}
        text={'Type'}
        isActive={sortColumn === 'type'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('filter')}
        activeSortType={sortOrder}
        text={'Filter'}
        iconName={'filter'}
        isActive={sortColumn === 'filter'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('groupby')}
        activeSortType={sortOrder}
        text={'Breakdown'}
        iconName={'breakdown'}
        isActive={sortColumn === 'groupby'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('deprecated')}
        activeSortType={sortOrder}
        text={'Disabled'}
        iconName={'eye-slash'}
        isActive={sortColumn === 'deprecated'}
        shouldAlignRight={false}
      />
      <SortableHeaderLabel
        onClick={onColumnClickFn('default')}
        activeSortType={sortOrder}
        text={'Modified'}
        iconName="pencil"
        isActive={sortColumn === 'default' && sortOrderOrNull !== null}
        shouldAlignRight={false}
      />
    </StyledFormUIRow>
  );
};

export default DataModelerFieldsGridHeader;
